// @ts-ignore
/* eslint-disable */
///////////////////////////////////////////////////////////////////////
//                                                                   //
// this file is autogenerated by service-generate                    //
// do not edit this file manually                                    //
//                                                                   //
///////////////////////////////////////////////////////////////////////
/// <reference path = "api-auto.d.ts" />
import request from '@/utils/ajax'

/**
 * Calculate pricing
 */
export async function PlanControllerCalculatePrice(
  params: Definitions.CalculatePriceDto,
): Promise<{
  error: string
  data: Definitions.CalculatePriceResultDto
}> {
  // /v1/plans/price
  let _params: { [key: string]: any } = {
    ...params,
  }
  return request.post(`/v1/plans/price`, {
    ..._params,
  })
}

/**
 * Get plan option list
 */
export async function PlanControllerGetPlanOptions(
  params: Paths.PlanControllerGetPlanOptions.BodyParameters,
): Promise<{
  error: string
  data: Paths.PlanControllerGetPlanOptions.Responses
}> {
  // /v1/plans/plan-options
  let _params: { [key: string]: any } = {
    ...params,
  }
  return request.get(`/v1/plans/plan-options`, {
    params: _params,
  })
}

/**
 * Get plan option list by region id
 */
export async function PlanControllerGetPlanOptionsByRegionId(
  params: Paths.PlanControllerGetPlanOptionsByRegionId.BodyParameters,
): Promise<{
  error: string
  data: Paths.PlanControllerGetPlanOptionsByRegionId.Responses
}> {
  // /v1/plans/plan-options/{sceneId}
  let _params: { [key: string]: any } = {
    ...params,
  }
  return request.get(`/v1/plans/plan-options/${_params.sceneId}`, {
    params: _params,
  })
}

/**
 * Get plan template list
 */
export async function PlanControllerGetPlanBundles(
  params: Paths.PlanControllerGetPlanBundles.BodyParameters,
): Promise<{
  error: string
  data: Paths.PlanControllerGetPlanBundles.Responses
}> {
  // /v1/plans/plan-bundles
  let _params: { [key: string]: any } = {
    ...params,
  }
  return request.get(`/v1/plans/plan-bundles`, {
    params: _params,
  })
}
